import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CommunityAccessCard = ({ hasAccess, communityUrl }) => {
  return (
    <div className="bg-card border border-border rounded-lg shadow-sm overflow-hidden">
      <div className="p-6 border-b border-border">
        <h3 className="text-lg font-heading font-semibold text-foreground">Skool Community Access</h3>
        <p className="text-sm text-muted-foreground mt-1">Connect with fellow authors and get exclusive content</p>
      </div>

      <div className="p-6">
        {hasAccess ? (
          <div className="space-y-4">
            <div className="flex items-center space-x-4 p-4 bg-success/5 border border-success/20 rounded-lg">
              <div className="w-12 h-12 bg-success/10 rounded-lg flex items-center justify-center">
                <Icon name="Users" size={24} className="text-success" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-foreground mb-1">Community Active</p>
                <p className="text-xs text-muted-foreground">
                  You have full access to the AuthorPreneur AI community
                </p>
              </div>
              <Icon name="CheckCircle" size={20} className="text-success" />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="p-4 bg-muted/30 rounded-lg">
                <div className="flex items-center space-x-2 mb-2">
                  <Icon name="MessageSquare" size={18} className="text-primary" />
                  <span className="text-xs text-muted-foreground">Active Discussions</span>
                </div>
                <p className="text-2xl font-heading font-bold text-foreground">247</p>
              </div>

              <div className="p-4 bg-muted/30 rounded-lg">
                <div className="flex items-center space-x-2 mb-2">
                  <Icon name="Users" size={18} className="text-secondary" />
                  <span className="text-xs text-muted-foreground">Community Members</span>
                </div>
                <p className="text-2xl font-heading font-bold text-foreground">1,834</p>
              </div>
            </div>

            <Button
              variant="default"
              size="default"
              fullWidth
              iconName="ExternalLink"
              iconPosition="right"
              onClick={() => window.open(communityUrl, '_blank')}
            >
              Visit Community
            </Button>

            <div className="p-4 bg-primary/5 border border-primary/20 rounded-lg">
              <div className="flex items-start space-x-3">
                <Icon name="Lightbulb" size={18} className="text-primary flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-medium text-foreground mb-1">Community Benefits</p>
                  <ul className="text-xs text-muted-foreground space-y-1">
                    <li>• Weekly live Q&amp;A sessions with publishing experts</li>
                    <li>• Exclusive book marketing strategies and templates</li>
                    <li>• Peer feedback on your book projects</li>
                    <li>• Early access to new AI features</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="flex items-center space-x-4 p-4 bg-warning/5 border border-warning/20 rounded-lg">
              <div className="w-12 h-12 bg-warning/10 rounded-lg flex items-center justify-center">
                <Icon name="Lock" size={24} className="text-warning" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-foreground mb-1">Access Locked</p>
                <p className="text-xs text-muted-foreground">
                  Upgrade to any paid plan to unlock community access
                </p>
              </div>
            </div>

            <div className="p-4 bg-muted/30 rounded-lg">
              <p className="text-sm text-foreground mb-3">What you'll get with community access:</p>
              <ul className="space-y-2">
                <li className="flex items-start space-x-2">
                  <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-muted-foreground">Connect with 1,800+ authors</span>
                </li>
                <li className="flex items-start space-x-2">
                  <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-muted-foreground">Weekly expert sessions</span>
                </li>
                <li className="flex items-start space-x-2">
                  <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-muted-foreground">Exclusive resources &amp; templates</span>
                </li>
                <li className="flex items-start space-x-2">
                  <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-muted-foreground">Early feature access</span>
                </li>
              </ul>
            </div>

            <Button
              variant="default"
              size="default"
              fullWidth
              iconName="Unlock"
              iconPosition="right"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              Upgrade to Access Community
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommunityAccessCard;